<template>
  <div class="boxall">
    <div class="title">物资集采</div>
    <div class="boxnav">
      <div class="bg-image" @click="handleImageClick">
        <!-- 轮播图片 -->
        <img
          v-for="(img, i) in images"
          :key="i"
          :src="img"
          class="bg-slide"
          :class="{ active: i === currentIndex }" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmerCollect',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  data() {
    return {
      currentIndex: 0,
      images: [
        require('../assets/images/farmer_products/goods1.jpeg'),
        require('../assets/images/farmer_products/goods2.jpeg'),
        require('../assets/images/farmer_products/goods5.png')
        // require('../assets/images/farmer_products/goods4.jpeg')
      ],
      timer: null
    }
  },

  mounted() {
    this.startTimer()
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length
        // 如果当前是展开状态，同步传出去
        if (this.activeComp === 'FarmerDetail') {
          this.$emit('syncIndex', this.currentIndex)
        }
      }, 5000)
    },

    // 把当前显示的图片索引传出去
    handleImageClick() {
      this.$emit('switchCenter', this.currentIndex)
      // console.log(this.currentIndex)
    }
  }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  cursor: pointer;
}

.bg-slide {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  opacity: 0;
  transition: opacity 2s ease;
  border-radius: 12px;
}

.bg-slide.active {
  opacity: 1;
}
</style>
